module.exports = __webpack_public_path__ + "2314fea9bca5c2f7e2c6fc88b8681c4c.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/god-splitter.mp4
// module id = 632
// module chunks = 0